import React from "react";
import TableSortLabel from "@mui/material/TableSortLabel";
import Box from "@mui/material/Box";
import { visuallyHidden } from "@mui/utils";

const SortLabel = ({
  "data-testid": dataTestId,
  headCellId,
  order,
  orderBy,
  createSortHandler,
  classes,
}) => {
  return (
    <TableSortLabel
      data-testid={dataTestId}
      direction={orderBy === headCellId ? order : "asc"}
      onClick={createSortHandler(headCellId)}
      classes={{
        icon:
          orderBy === headCellId
            ? classes.activeSortIcon
            : classes.inactiveSortIcon,
      }}
    >
      {orderBy === headCellId ? (
        <Box component="span" sx={visuallyHidden}>
          {order === "desc" ? "sorted descending" : "sorted ascending"}
        </Box>
      ) : null}
    </TableSortLabel>
  );
};

export default SortLabel;
